import React, {useContext, useEffect, useState} from "react";
import {useAuth0} from "@auth0/auth0-react";
import "../../App.css";
import __ from "lodash";
import {makeStyles, useTheme} from "@material-ui/core/styles";
import PageHeader from "../../blocks/PageHeader.js";
import PageFooter from "../../blocks/PageFooter";
import MessageManagementStyles from "./styles/AwbStockManagementStyles";
import AwbStockSelector from "./components/AwbStockSelector";
import AwbStockAllocationsList from "./components/AwbStockAllocationsList";
import AwbAllocatedStockList from "./components/AwbAllocatedStockList";

const AccessControl = require ("../../AccessControl");


function AwbStockManagement(props) {
  const classes = makeStyles(MessageManagementStyles)();

  const { isAuthenticated, user } = useAuth0();
  const canEdit = AccessControl.userHasAccess(user, ["Super Admin", "Admin", "Manage STOCK"]);
  const canAddOldStock = AccessControl.userHasAccess(user, ["Super Admin", "Manage OLD STOCK"]);

  let theme = useTheme();
  const values = {
    xs: 0,
    sm: 600,
    lsm: 720,
    md: 960,
    mlg: 1120,
    lg: 1280,
    lgr: 1750,
    xl: 1920,
    xxl: 2400
  };

  theme.breakpoints = {...theme.breakpoints,
    keys: ['xs', 'sm', 'lsm', 'md', 'mlg', 'lg', 'lgr', 'xl', 'xxl'],
    up: key => `@media (min-width:${values[key]}px)`,
  };

  return (isAuthenticated &&
    <div
      className="AwbStockManagement"
      style={{
        backgroundColor: "#eeeeee",
        color: "#1b4481",
        fontWeight: 400,
        fontFamily: "Ubuntu,sans-serif",
        minHeight: "100vh",
      }}
    >
      <PageHeader
        parentProps={props}
        activeMenuItem="messagemanagement"
        pageName="Air Waybill Stock Management"
        loggedInUser={user}
        logout={""}
      ></PageHeader>
      <div
        style={{
          marginLeft: 40,
          marginRight: 40,
          height: 2,
          backgroundColor: "#b7c3d4",
        }}
      ></div>
      <div style={{ height: 10 }}></div>

      <div className={classes.rooted} style={{width: "100%", height: 70, display: "block"}}>
        <div className={classes.rooted} style={{height: "100%", display: "block", marginLeft: 40, marginRight: 40, backgroundColor: "#ffffff"}}>
          <AwbStockSelector classes={classes} canEdit={canEdit}/>
        </div>
      </div>
      <div style={{height: 10}}></div>

      <div
        className={classes.rooted}
        style={{ marginLeft: 20, marginRight: 20, minHeight: `calc(100vh - ${(99+2+10+57+4+16+68)}px)`, height: `calc(100vh - ${(99+2+10+57+4+16+68)}px)` }}
      >
        <div style={{display: "flex", width: "100%", position: "relative"}}>
          <div style={{display: "inline-flex", width: 1000, MinWidth: 970, maxWidth: 970, height: "100%"}}>
            <AwbStockAllocationsList
              canEdit={canEdit}
              classes={classes}
              theme={theme}
              height={99+2+10+57+4+16+68}
              canAddOldStock={canAddOldStock}
            />
          </div>
          <div style={{display: "inline-flex", position: "relative", width: `calc(100vw - 1065px)`, maxWidth: `calc(100vw - 1065px)`, marginLeft:20, backgroundColor: "#ffffff"}}>
            <AwbAllocatedStockList
              canEdit={true}
              classes={classes}
              theme={theme}
              height={99+2+10+57+4+16+68}
            />
          </div>
        </div>
      </div>

      <PageFooter></PageFooter>
    </div>
  );
}

export default AwbStockManagement;
